import Gallery, { Animation } from '../../Gallery';
import React, { useState } from 'react';
import { quoteActionTypes, useQuote } from '../../../context/Quote';

import BundledProducts from './BundledProducts';
import { IconTypes } from '../../generic/Icon';
import Image from '../../generic/Image';
import MountingOptions from '../MountingOptions';
import Pricing from '../Pricing';
import { PrimaryButton } from '../../generic/Button';
import { ProductAvailability } from '../../../constants/contentful';
import RichText from '../../generic/RichText';
import styles from './index.module.scss';
import { useIsQuoteButtonsEnabled } from '../../../utils';
import { useQuoteVisibility } from '../../../context/QuoteVisbility';

// import { useSiteMetadata } from '../../../utils/useSiteMetaData';

/**
 *
 * @param {object} props
 * @param {import('../../../context/Quote').InventoryType} props.item
 * @returns {JSX.Element}
 */
export default function ProductListContent({ item }) {
  // let {
  //   phrases: { AddToOrder: "buyButtonLabel" },
  // } = useSiteMetadata();

  const { toggleQuote } = useQuoteVisibility();

  // Legacy image handling
  const [defaultVersion] = item.productMounts || [];
  const [selectedMountOrProductId, setSelectedMountId] = useState(defaultVersion?.mount.id || item?.id);

  const body = item.__typename === 'ContentfulProduct' ? item.body : item.product.body;
  const images = (item.__typename === 'ContentfulProduct' ? item.images : item.product.images) || [];
  const currentProductImage = images[0].image;

  // Gallery data
  const mountImages =
    item.productMounts
      ?.map(({ mount: { id, heading, image } }) => {
        return { id, image, heading };
      })
      .flat(1) || [];
  const gallerySlides = [...mountImages, ...images];
  const [overrideSlideIndex, setOverrideSlideIndex] = useState(-1);

  // Mount Selection
  const onSelectedMount = mountId => {
    setSelectedMountId(mountId);
    var index = gallerySlides
      ?.map(el => {
        return el.id;
      })
      .indexOf(mountId);
    setOverrideSlideIndex(index);
    return mountId;
  };

  // Adding to quote
  let isQuoteButtonsEnabled = useIsQuoteButtonsEnabled();
  let { dispatchQuote } = useQuote();
  let addProduct = mount => {
    dispatchQuote({
      type: quoteActionTypes.add,
      item, //todo remove after merge with `feature/shop`
      payload: {
        item,
        label: `ProductList 'Add to quote' clicked`,
        mount,
      },
    });
    toggleQuote();
  };

  if (!item) return null;

  const formatHeading = heading => {
    const headingWords = heading.split(' ');
    const webexIndex = headingWords.indexOf('Webex');
    if (webexIndex > -1) {
      return (
        <>
          {headingWords.slice(0, webexIndex + 1).join(' ')} <br />
          {headingWords.slice(webexIndex + 1).join(' ')}
        </>
      );
    }
    return item.heading;
  };

  return (
    <div className={styles.productGridContent}>
      <div className={styles.content}>
        <h3 className={styles.header}>{formatHeading(item.heading)}</h3>
        <RichText className={styles.richText} imageClassName={styles.embeddedImage} linkIcons>
          {body}
        </RichText>
        <MountingOptions product={item} onSelectedMount={onSelectedMount} />
        {'includedProducts' in item && <BundledProducts products={item.includedProducts} />}
        <Pricing product={item} />
      </div>
      <div className={styles.images}>
        <div className={styles.image}>
          {images?.length ? (
            <Gallery
              slides={gallerySlides}
              animation={Animation.fade}
              showHeading={false}
              showButtonControls={false}
              showTextArea={false}
              overrideSlideIndex={overrideSlideIndex}
            />
          ) : (
            // Legacy image handling
            Boolean(currentProductImage?.fluid) && (
              <Image
                style={{ objectFit: 'contain' }}
                fluid={currentProductImage?.fluid}
                imgStyle={{ objectFit: 'contain' }}
                alt={currentProductImage?.description?.description || currentProductImage?.description}
              />
            )
          )}
        </div>
      </div>
      {isQuoteButtonsEnabled && item.availability === ProductAvailability.Available && (
        <div className={styles.buttonContainer}>
          <PrimaryButton
            iconType={IconTypes.quote}
            clickHandler={() =>
              addProduct(item.productMounts?.find(({ mount: { id } }) => id === selectedMountOrProductId))
            }
            className={styles.addToQuoteButton}
          >
            Add to Quote
          </PrimaryButton>
        </div>
      )}
    </div>
  );
}
